import { render, staticRenderFns } from "./ErrorInfo.vue?vue&type=template&id=71299db6&scoped=true"
import script from "./ErrorInfo.vue?vue&type=script&lang=js"
export * from "./ErrorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71299db6",
  null
  
)

export default component.exports